/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiMemberDtoRefundInfoDto
 */
export interface WebApiMemberDtoRefundInfoDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoRefundInfoDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoRefundInfoDto
     */
    amount?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoRefundInfoDto
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoRefundInfoDto
     */
    createdByName?: string | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoRefundInfoDto interface.
 */
export function instanceOfWebApiMemberDtoRefundInfoDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoRefundInfoDtoFromJSON(json: any): WebApiMemberDtoRefundInfoDto {
    return WebApiMemberDtoRefundInfoDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoRefundInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoRefundInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'createdByName': !exists(json, 'createdByName') ? undefined : json['createdByName'],
    };
}

export function WebApiMemberDtoRefundInfoDtoToJSON(value?: WebApiMemberDtoRefundInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'createdByName': value.createdByName,
    };
}

